if (!customElements.get('km-product-pilot')) {

  customElements.define('km-product-pilot', class extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.form = this.querySelector('form');

      this.slides = this.querySelector('.km-pilot__slides');

      this.thumbs = [...this.querySelectorAll('[data-slide]')];

      this.dialog = this.querySelector('dialog');

      this.index = 0;

      this.thumbs.forEach(button => button.addEventListener('click', () => this.goTo(Number(button.dataset.slide))));

      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.goTo(this.index + Number(button.dataset.direction))));

      this.onScroll = () => {

        cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {

          this.index = Math.round(this.slides.scrollLeft / this.slides.clientWidth);

          this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));

          this.querySelector('[data-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.thumbs.length).padStart(2, '0')}`;

        });

      };

      this.slides.addEventListener('scroll', this.onScroll, { passive: true });

      this.slides.addEventListener('keydown', event => {

        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

        event.preventDefault();

        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));

      });

      this.querySelector('[data-open-guide]').addEventListener('click', event => { event.preventDefault(); this.dialog.showModal(); });

      this.querySelector('[data-close-guide]').addEventListener('click', () => this.dialog.close());

      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } });

      this.form.addEventListener('change', event => {

        if (event.target.name !== 'id') return;

        const choice = event.target;

        if (choice.disabled) return;

        this.form.querySelector('[type="submit"]').disabled = false;
        this.querySelector('[data-add-label]').textContent = this.dataset.addLabel;
        this.querySelector('[data-sticky] button').textContent = `${this.dataset.shortLabel} ↗`;
        this.querySelector('[data-availability-note]').hidden = true;

        this.querySelector('[data-sticky] button').disabled = false;

        this.querySelector('[data-size]').textContent = choice.dataset.title;

        this.querySelector('[data-price]').textContent = choice.dataset.price;

        this.querySelector('[data-sticky-price]').textContent = choice.dataset.price;

        const url = new URL(location.href);

        url.searchParams.set('variant', choice.value);

        history.replaceState({}, '', url);

      });

      this.form.addEventListener('submit', event => this.addToCart(event));

      this.observer = new IntersectionObserver(entries => { this.querySelector('[data-sticky]').hidden = entries[0].isIntersecting; }, { threshold: 0 });

      this.observer.observe(this.form.querySelector('[type="submit"]'));

    }

    disconnectedCallback() {

      this.observer?.disconnect();

      cancelAnimationFrame(this.scrollFrame);

    }

    goTo(index) {

      const next = (index + this.thumbs.length) % this.thumbs.length;

      this.slides.scrollTo({ left: next * this.slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });

    }

    async addToCart(event) {

      event.preventDefault();

      if (this.busy || !this.form.querySelector('input[name="id"]:checked:not(:disabled)')) return;

      this.busy = true;

      const buttons = [this.form.querySelector('[type="submit"]'), this.querySelector('[data-sticky] button')];

      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });

      const error = this.querySelector('[data-form-error]');

      error.hidden = true;

      let added = false;

      try {

        const body = new FormData(this.form);

        const cart = document.querySelector('cart-drawer');

        if (cart?.getSectionsToRender) {

          body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));

          body.append('sections_url', location.pathname);

          cart.setActiveElement(this.form.querySelector('[type="submit"]'));

        }

        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body });

        const result = await response.json();

        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);

        added = true;

        if (cart?.renderContents && result.sections) {

          cart.classList.remove('is-empty');

          cart.renderContents(result);

        } else location.assign(this.dataset.cartUrl);

      } catch (exception) {

        if (added) location.assign(this.dataset.cartUrl);

        else { error.textContent = exception.message || this.dataset.error; error.hidden = false; error.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }

      } finally {

        this.busy = false;

        buttons.forEach(button => { button.disabled = !this.form.querySelector('input[name="id"]:checked:not(:disabled)'); button.removeAttribute('aria-busy'); });

      }

    }

  });

}

